const logger = require('loglevel');
const log = logger.getLogger('default');

if (process.env.REACT_APP_ENVIRONMENT !== 'production')
    log.setLevel('trace');
else log.setLevel('error');

export default log;

